<template>
    <section>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon class="white--text">
                                {{ mdiDoctor }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Affiliated Doctors
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />

            <!-- Combo boxes -->
            <div class="comboBox d-flex justify-space-around align-center flex-wrap">
                <!-- Specialization -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiStethoscope }}
                        </v-icon>
                    </v-avatar>
                    <v-autocomplete
                        v-model="specialization"
                        color="green accent-4"
                        label="Specialization"
                        :items="getSpecializations"
                        item-text="sp_name"
                        auto-select-first
                        item-value="sp_desc"
                        autocomplete="nope"
                        @change="
                            doctors({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                SP: specialization,
                            }),
                            specializations()
                        "
                    />
                </div>

                <!-- Regions -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiMapMarker }}
                        </v-icon>
                    </v-avatar>

                    <v-combobox
                        v-model="region"
                        color="green accent-4"
                        label="Region"
                        :items="getRegions"
                        autocomplete="nope"
                        @change="
                            (city = ''),
                            (province = ''),
                            doctors({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                SP: specialization,
                            }),
                            provinces({ REGION: region })
                        "
                    />
                </div>

                <!-- Provinces -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiMap }}
                        </v-icon>
                    </v-avatar>
                    <v-combobox
                        v-model="province"
                        color="green accent-4"
                        label="Province"
                        :items="getProvinces"
                        autocomplete="nope"
                        @change="
                            (city = ''),
                            doctors({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                SP: specialization,
                            }),
                            cities({ REGION: region, PROVINCE: province })
                        "
                    />
                </div>

                <!-- City -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiCity }}
                        </v-icon>
                    </v-avatar>
                    <v-combobox
                        v-model="city"
                        color="green accent-4"
                        label="City"
                        :items="getCities"
                        autocomplete="nope"
                        @change="
                            doctors({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                SP: specialization,
                            })
                        "
                    />
                </div>
            </div>

            <!-- End Combo boxes -->

            <div class="txtFieldWrapper">
                <v-text-field
                    v-model="searchDoc"
                    label="Search Doctor"
                    :prepend-icon="mdiMagnify"
                    outlined
                    autocomplete="nope"
                    color="green"
                    hide-details
                />
            </div>

            <div v-if="getDoctors">
                <div style="background-color: white; padding: 3px; border-radius: 5px;">
                    <v-alert
                        color="teal darken-3"
                        outlined
                        style="margin: 0;"
                        type="info"
                    >
                        <span>Disclaimer: The schedule and accreditation status of each doctor may change before updates are reflected in this list.</span>
                    </v-alert>
                </div>
                <v-data-table
                    :headers="headers"
                    :search="searchDoc.toUpperCase()"
                    :items="doctors_data"
                    :items-per-page="10"
                    no-data-text
                    :footer-props="footer_props"
                    class="my-1 elevation-10"
                    :class="{ mobile: screen_width < 968 }"
                    :hide-headers="true"
                >
                    <template #item="{ item }">
                        <tr
                            v-if="screen_width < 600"
                            class="doctorTblRow"
                            @click="showDialog(item.doc_name)"
                        >
                            <td colspan="5">
                                <ul class="flex-content">
                                    <div class="content d-flex justify-space-between">
                                        <label>Name</label>
                                        <li class="flex-item">
                                            {{ item.doc_name }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Specialization</label>
                                        <li class="flex-item">
                                            {{ item.sp_desc }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>City</label>
                                        <li class="flex-item">
                                            {{ item.city_name }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Province</label>
                                        <li class="flex-item">
                                            {{ item.city_province }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Region</label>
                                        <li class="flex-item">
                                            {{ item.city_region }}
                                        </li>
                                    </div>
                                </ul>
                            </td>
                        </tr>
                        <tr v-else @click="showDialog(item.doc_name)">
                            <td v-text="item.doc_name"></td>
                            <td v-text="item.sp_desc"></td>
                            <td v-text="item.city_name"></td>
                            <td v-text="item.city_province"></td>
                            <td v-text="item.city_region"></td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <div v-else>
                <v-skeleton-loader
                    class="mx-auto"
                    width="80%"
                    type="table"
                />
            </div>

            <!-- Dialog Box -->
            <DialogBox
                :doctor="showDoctor"
                :doctor-data="getDoctorDialog"
                :show="showTable"
                @showDialog="showProp"
            />
        </v-container>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBox from './DoctorsDialog.vue'
import { mdiArrowLeft, mdiCity, mdiDoctor, mdiMagnify, mdiMap, mdiMapMarker, mdiStethoscope } from '@mdi/js'

export default {
    components: { DialogBox },
    data: () => ({
        mdiArrowLeft,
        mdiDoctor,
        mdiStethoscope,
        mdiMap,
        mdiMapMarker,
        mdiCity,
        mdiMagnify,
        screen_width: document.documentElement.clientWidth + 9,
        searchDoc: '',
        region: 'NCR',
        province: '',
        city: '',
        specialization: '',
        showTable: false,
        showDoctor: null,
        footer_props: {
            'items-per-page-options': []
        },
        headers: [
            {
                text: 'Name',
                align: 'left',
                value: 'doc_name',
                class: 'teal--text'
            },
            {
                text: 'Specialization',
                align: 'left',
                value: 'sp_desc',
                class: 'teal--text'
            },
            {
                text: 'City',
                align: 'left',
                value: 'city_name',
                class: 'teal--text'
            },
            {
                text: 'Province',
                align: 'left',
                value: 'city_province',
                class: 'teal--text'
            },
            {
                text: 'Region',
                align: 'left',
                value: 'city_region',
                class: 'teal--text'
            }
        ]
    }),
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getSpecializations', 'getDoctors', 'getDoctorDialog']),
        doctors_data: {
            get() {
                let dataArr = this.getDoctors
                for (let i = 0; i < dataArr.length; i++) {
                    dataArr[i].sp_desc = this.wrapSpecializations(dataArr[i])
                }
                return dataArr
            }
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    created() {
        this.regions()
        this.provinces({ REGION: this.region })
        this.specializations()
        this.doctors({
            REGION: this.region,
            PROVINCE: this.province,
            CITY: this.city,
            SP: this.specialization
        })
    },
    methods: {
        ...mapActions(['regions', 'provinces', 'cities', 'specializations', 'doctors', 'getCsrfToken', 'doctorsDialog']),
        async showDialog(name) {
            this.showDoctor = name
            await this.doctorsDialog({
                DOC_NAME: name
            })
            this.showProp(true)
        },
        showProp(show) {
            this.showTable = show
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        wrapSpecializations({ doc_specialization_1, doc_specialization_2, doc_specialization_3 }) {

            let spec_str = []

            if(doc_specialization_1 !== null && String(doc_specialization_1).trim() !== '') spec_str.push(String(doc_specialization_1).trim())
            if(doc_specialization_2 !== null && String(doc_specialization_2).trim() !== '') spec_str.push(String(doc_specialization_2).trim())
            if(doc_specialization_3 !== null && String(doc_specialization_3).trim() !== '') spec_str.push(String(doc_specialization_3).trim())

            let str = ''
            for (let i = 0; i < spec_str.length; i++) {
                str += spec_str[i]
                if(i < spec_str.length - 1) {
                    str += ' - '
                }
            }

            return str

        }
    }
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.doctorTblRow td ul div li {
    min-height: 40px;
    height: auto;
    padding-top: 10px;
}
.doctorTblRow td ul div label {
    padding-top: 10px;
    font-weight: 600;
}
.doctorTblRow td ul div {
    width: 100%;
}
.txtFieldWrapper {
  width: 60%;
  margin: 20px auto;
}
.comboWrapper {
  width: 20%;
  margin: 20px 0px 0px 0px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  .comboWrapper,
  .txtFieldWrapper {
    width: 90%;
  }
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (min-width: 599px) and (max-width: 968px) {
  @media (min-width: 599px) and (max-width: 968px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }

    .comboWrapper,
    .txtFieldWrapper {
      width: 60%;
    }
  }
}

table tr td {
  cursor: pointer;
}
</style>
